<template>
  <md-checkbox class="md-checkbox" :model="checked ? value : ''" :value="value" @change="handleChange">{{
    label
  }}</md-checkbox>
</template>

<script>
export default {
  name: "MuiCheckbox",
  props: {
    value: {
      type: [String, Number, Boolean],
      default: "",
    },
    label: {
      type: String,
      default: "",
    },
    checked: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleChange(value) {
      this.$emit("change", value);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";

.md-checkbox {
  margin-right: 5px;
  // 动画不支持，所以隐藏动画，否则会造成元素闪显闪隐
  ::v-deep .md-ripple {
    display: none;
  }

  &.md-checked {
    ::v-deep .md-checkbox-container {
      background-color: $success !important;
      border-color: $success !important;
    }
  }
}
</style>
